import { AuditSchedule } from '@mi-front/core';
import { Chip, Tooltip } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { LDateTime } from '../../../../components/date/LDateTime';

export function ScheduleMatchStatus(p: { schedule: AuditSchedule; size?: 'sm' }) {
  const { schedule } = p;

  if (!schedule.matches?.length) {
    return (
      <Chip
        label={
          <FormattedMessage id="audit.schedulesListScreen.noMatch" defaultMessage="Sin match" />
        }
      />
    );
  }

  const match = schedule.matches[0];
  const defaultConfirmation =
    match &&
    (!match.matchedScheduleConfirmationType || match.matchedScheduleConfirmationType === 'DEFAULT');

  const badgeContent = (
    <>
      <LDateTime value={match.datetime} />
      &nbsp; - Diff: {match.matchedScheduleDiff?.toFixed(1)} min
    </>
  );

  const chip = (
    <Chip
      size={p.size === 'sm' ? 'small' : 'medium'}
      color={defaultConfirmation ? 'success' : 'warning'}
      label={badgeContent}
    />
  );

  return (
    <Tooltip
      title={
        defaultConfirmation ? (
          ''
        ) : (
          <FormattedMessage
            id="audit.scheduleStatusScreen.detailModal.offTolerance"
            defaultMessage="La confirmación de schedule está fuera de la tolerancia permitida"
          />
        )
      }
      placement="left"
    >
      {chip}
    </Tooltip>
  );
}
